const extractDomainName = (url: string | undefined) => {
	if (!url) return undefined;
	const domain = url.replace("http://", "").replace("https://", "").split(/[/?#]/)[0];
	return domain;
};
export default extractDomainName;
